class OiBlogReadingProgress extends HTMLElement {
  connectedCallback() {
    this.progress = this.querySelector('[data-reading-progress]');
    this.copyButtons = document.querySelectorAll('[data-copy-link]');
    this.article = document.querySelector('[data-article-content]');
    this.handleScroll = this.update.bind(this);
    this.handleCopy = this.copyLink.bind(this);

    if (this.progress && this.article) {
      // No desktop o Dwell rola `.page-wrapper`, não a janela; a captura no document pega os dois casos.
      document.addEventListener('scroll', this.handleScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      this.update();
    }

    this.copyButtons.forEach((button) => button.addEventListener('click', this.handleCopy));
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.handleScroll, { capture: true });
    window.removeEventListener('resize', this.handleScroll);
    this.copyButtons.forEach((button) => button.removeEventListener('click', this.handleCopy));
  }

  update() {
    const rect = this.article.getBoundingClientRect();
    const distance = rect.height - window.innerHeight;
    const value = distance <= 0 ? 1 : Math.min(1, Math.max(0, -rect.top / distance));
    this.progress.style.setProperty('--oi-reading-progress', `${value * 100}%`);
    this.progress.setAttribute('aria-valuenow', String(Math.round(value * 100)));
  }

  async copyLink(event) {
    const button = event.currentTarget;

    try {
      await navigator.clipboard.writeText(window.location.href);
      // Botões só com ícone: a confirmação vem do CSS (.is-copied) e do aria-label.
      const label = button.getAttribute('aria-label');
      button.classList.add('is-copied');
      button.setAttribute('aria-label', button.dataset.copiedLabel);
      window.setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) button.setAttribute('aria-label', label);
      }, 2000);
    } catch {
      window.prompt(button.dataset.fallbackLabel, window.location.href);
    }
  }
}

if (!customElements.get('oi-blog-reading-progress')) {
  customElements.define('oi-blog-reading-progress', OiBlogReadingProgress);
}
